import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { getPendingOrderReports } from '@data'
import { showLoader } from '@data/state/action'
import { CardDetail, MainWrapper, Wrapper } from '../CompanyReport'
import { strings } from '@constants'
import { Button, H4, Table } from '@base'
import { ItemWrapper } from '@pages/Dashboard/styles'
import { Spacings } from '@styles'
import { Business, Eco, FilterDrama, FitnessCenter, Grain, Money } from '@material-ui/icons'
import { convertDataFile, dataArrayToCsv } from '@utils'

const TableWrapper = styled(ItemWrapper)`
	width: 100%;
	& > div:nth-child(1) {
		margin-bottom: ${Spacings.SPACING_3B};
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}
`

const TableHeading = styled(H4)``

const PendingOrderReports = () => {
	const dispatch = useDispatch()
	const [cardList, setCardList] = useState([])
	const [reportsData, setReportsData] = useState([])

	const getCardIcon = (key) => {
		switch (key) {
			case 'SCRAP':
				return <Grain />
			case 'MARKETPLACE':
				return <Business />
			case 'CLOUD_FACTORY':
				return <FilterDrama />
			case 'NON_FERROUS':
				return <Eco />
			case 'TOTAL':
				return <FitnessCenter />
			default:
				return <Money />
		}
	}

	useEffect(() => {
		dispatch(showLoader(true))
		getPendingOrderReports()
			.then((response) => {
				setCardList(Object.entries(response?.by_platform).map(([key, value]) => ({ key, value })))
				let xyz = []
				Object.entries(response).map(([key, value]) => {
					if (Array.isArray(value)) {
						xyz.push({ key: key, value: value })
					}
				})
				setReportsData(xyz)
			})
			.catch((error) => {})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [])

	const getColumns = (key) => {
		let tableColumns
		switch (key) {
			case 'by_region':
				tableColumns = [
					{ label: 'Business Region', key: 'region', mobile: true },
					{ label: 'MARKETPLACE', key: 'MARKETPLACE', mobile: true },
					{ label: 'CLOUD FACTORY', key: 'CLOUD_FACTORY', mobile: true },
					{ label: 'SCRAP', key: 'SCRAP', mobile: true },
					{ label: 'BITUMEN', key: 'BITUMEN', mobile: true },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true },
				]
				break
			case 'by_supply_spoc_and_date':
				tableColumns = [
					{ label: 'Supply SPOC', key: 'supply_spoc', mobile: true },
					{ label: '0 to 7', key: '0 to 7', mobile: true },
					{ label: '7 to 14', key: '7 to 14', mobile: true },
					{ label: '14 to 21', key: '14 to 21', mobile: true },
					{ label: '21 to 28', key: '28 to 35', mobile: true },
					{ label: '35 to 42', key: '35 to 42', mobile: true },
					{ label: '42 to 49', key: '42 to 49', mobile: true },
					{ label: '49 to 56', key: '49 to 56', mobile: true },
					{ label: '56 to 63', key: '56 to 63', mobile: true },
					{ label: '63 to 70', key: '63 to 70', mobile: true },
					{ label: '70 to 77', key: '70 to 77', mobile: true },
					{ label: '77 to 84', key: '77 to 84', mobile: true },
					{ label: '84+', key: '84+', mobile: true },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true },
				]
				break
			case 'by_supply_spoc_and_region':
				tableColumns = [
					{ label: 'Supply SPOC', key: 'supply_spoc', mobile: true },
					{ label: 'EAST', key: 'EAST', mobile: true },
					{ label: 'NORTH', key: 'NORTH', mobile: true },
					{ label: 'RAJASTHAN', key: 'RAJASTHAN', mobile: true },
					{ label: 'SOUTH', key: 'SOUTH', mobile: true },
					{ label: 'WEST', key: 'WEST', mobile: true },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true },
				]
				break
			case 'by_supply_spoc_and_platform':
				tableColumns = [
					{ label: 'Supply SPOC', key: 'supply_spoc', mobile: true },
					{ label: 'BITUMEN', key: 'BITUMEN', mobile: true },
					{ label: 'CLOUD FACTORY', key: 'CLOUD_FACTORY', mobile: true },
					{ label: 'MARKETPLACE', key: 'MARKETPLACE', mobile: true },
					{ label: 'SCRAP', key: 'SCRAP', mobile: true },
					{ label: 'NON FERROUS', key: 'NON_FERROUS', mobile: true },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true },
				]
				break
			case 'by_customer':
				tableColumns = [
					{ label: 'Supply SPOC', key: 'supply_spoc', mobile: true },
					{ label: 'Customer Name', key: 'customer_name', mobile: true },
					{ label: 'BITUMEN', key: 'BITUMEN', mobile: true },
					{ label: 'CLOUD FACTORY', key: 'CLOUD_FACTORY', mobile: true },
					{ label: 'MARKETPLACE', key: 'MARKETPLACE', mobile: true },
					{ label: 'SCRAP', key: 'SCRAP', mobile: true },
					{ label: 'NON FERROUS', key: 'NON_FERROUS', mobile: true },
					{ label: 'TOTAL', key: 'TOTAL', mobile: true },
				]
				break
			default:
				tableColumns = []
				break
		}
		return tableColumns
	}

	const getHeading = (key) => {
		let heading = ''
		switch (key) {
			case 'by_region':
				heading = 'Category Zone Wise Pending (in MT)'
				break
			case 'by_supply_spoc_and_date':
				heading = 'Pending Orders Age Buckets Quantity (in MT)'
				break
			case 'by_supply_spoc_and_region':
				heading = 'Supply SPOC wise Pending (in MT)'
				break
			case 'by_supply_spoc_and_platform':
				heading = 'Pending Orders Supply SPOC Summary (in MT)'
				break
			case 'by_customer':
				heading = 'Pending Orders Supply SPOC and Customer Wise (in MT)'
				break
			default:
				break
		}
		return heading
	}

	const exportHandler = (key, data) => {
		const csvData = dataArrayToCsv(getColumns(key), data)
		const fileName = `${key} report`
		convertDataFile(csvData, fileName)
	}

	return (
		<Wrapper>
			<MainWrapper>
				{cardList?.map((item) => {
					return <CardDetail heading={item.key} value={`${item.value} MT`} hasDefinition={false} icon={getCardIcon(item?.key)} />
				})}
			</MainWrapper>

			{reportsData?.map((item) => {
				return (
					<TableWrapper fullWidth>
						<div>
							<TableHeading>{getHeading(item.key)}</TableHeading>
							<Button small type='primary' onClick={() => exportHandler(item.key, item?.value)}>
								{strings('export')}
							</Button>
						</div>

						<Table
							// noScroll
							fullHeight
							data={item?.value}
							columns={getColumns(item?.key)}
							loading={false}
							rowClickable={false}
							hideFooter
						/>
					</TableWrapper>
				)
			})}
		</Wrapper>
	)
}

export default PendingOrderReports
